<template>
  <tr class="lot-row">
    <td>
      <div class="text-center">
        #{{ lot.lotId }}
      </div>
    </td>
    <td>
      <a target="_blank" :href="googleLink">
        <span class="fa fa-map-marker-alt fa-fw"></span> {{ lot.address }}
      </a>
    </td>
    <td>
      <div class="text-center">
        {{ lot.washFrequencyTitle }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ lot.municipality }}
      </div>
    </td>
    <td>
      <div class="text-center">
        <checkbox-input
          :options="{ fullWidth: true }"
          :value="lot.hasOvernight"
          @input="toggleOvernight(lot)">
        </checkbox-input>
      </div>
    </td>
    <td>
      <div class="text-center">
        <checkbox-input
          :options="{ fullWidth: true }"
          :value="lot.hasWeekend"
          @input="toggleWeekend(lot)">
        </checkbox-input>
      </div>
    </td>
    <td>
      <div class="text-center">
        <checkbox-input
          :options="{ fullWidth: true }"
          :value="lot.oneWayTrips"
          @input="toggleOneWayTrips(lot)">
        </checkbox-input>
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ lot.bays }}
      </div>
    </td>
    <td>
      <span :class="status.class" class="label label-wrap">
        {{ status.text }}
      </span>
    </td>
    <td>
      <button v-if="!lot.closed" @click="close(lot)" class="btn btn-sm btn-danger" :disabled="parseInt(lot.carsCount) > 0">
        <span class="fa fa-ban fa-fw"></span> Close
      </button>
      <button v-if="lot.closed" @click="open(lot)" class="btn btn-sm btn-success">
        <span class="fa fa-undo fa-fw"></span> Reopen
      </button>
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="'/fleet/lots/edit/' + lot.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput'
import { mapActions } from 'vuex'
import {
  OPEN_LOT,
  CLOSE_LOT,
  TOGGLE_LOT_OVERNIGHT,
  TOGGLE_LOT_WEEKEND,
  TOGGLE_LOT_ONE_WAY_TRIPS
} from '@/vuex/types'
export default {
  name: 'LotRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    CheckboxInput
  },
  computed: {
    status () {
      if (parseInt(this.lot.carsCount) === 0 && !this.lot.closed) {
        return { class: 'label-danger', text: 'Lot Empty' }
      } else if (parseInt(this.lot.carsCount) > 0) {
        if (this.lot.bays > parseInt(this.lot.carsCount)) {
          return { class: 'label-primary', text: 'Bays Available: ' + (this.lot.bays - this.lot.carsCount) }
        } else {
          return { class: 'label-warning', text: 'Lot Full' }
        }
      } else {
        return { class: 'label-default', text: 'Lot Closed' }
      }
    },
    googleLink () {
      return 'https://maps.google.com/?q=' + this.lot.latitude + ',' +
      this.lot.longitude
    },
    lot () {
      return {
        ...this.object,
        ...this.updatedLot
      }
    }
  },
  data () {
    return {
      updatedLot: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedLot = result.updated
    },
    toggleOvernight (lot) {
      this.executeAction(TOGGLE_LOT_OVERNIGHT, lot)
    },
    toggleWeekend (lot) {
      this.executeAction(TOGGLE_LOT_WEEKEND, lot)
    },
    toggleOneWayTrips (lot) {
      this.executeAction(TOGGLE_LOT_ONE_WAY_TRIPS, lot)
    },
    close (lot) {
      this.executeAction(CLOSE_LOT, lot)
    },
    open (lot) {
      this.executeAction(OPEN_LOT, lot)
    },
    ...mapActions([
      OPEN_LOT,
      CLOSE_LOT,
      TOGGLE_LOT_OVERNIGHT,
      TOGGLE_LOT_WEEKEND,
      TOGGLE_LOT_ONE_WAY_TRIPS
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Lot.vue